<template>
<div class="si-home">

      <div class="row">
        <div class="col s3 yo-text-bold" v-if="societa.tipo!='RIVISTA'">Tipo Socio</div>
        <div class="col s9" v-if="societa.tipo!='RIVISTA'">{{item.tiposocio | items($teras._tiposocio,'nome')}} </div>

        <div class="col s3 yo-text-bold" v-if="societa.tipo!='RIVISTA'">Data di approvazione</div>
        <div class="col s9" v-if="societa.tipo!='RIVISTA'">{{item.giorno | data('DD MMMM YYYY')}} </div>

        <div class="col s3 yo-text-bold" v-if="societa.tipo!='RIVISTA'">Regione</div>
        <div class="col s9" v-if="societa.tipo!='RIVISTA'">{{item.regione}} </div>

        <div class="col s3 yo-text-bold">Saldo</div>
        <div class="col s9">{{item.saldo | money('€ ')}} </div>

        <div class="col s1 offset-s11 yo-align-center"><el-tooltip content="Modifica i dati della sottoscrizione" placement="right"><router-link class="yo-button small" :to="'/si-edit/'+item.societa+'/'+item.id" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">edit</i></router-link></el-tooltip></div>
      </div>



      <div class="yo-color-primary yo-text-n yo-text-bold" style="margin-top:10px;"></div>

      <div class="row row-head">
        <div class="col s2 yo-align-center">ANNO</div>
        <div class="col s3">IMPORTO</div>
        <div class="col s6">SCONTO</div>
        <div class="col s1 yo-align-center"><el-tooltip content="Nuovo rinnovo" placement="right"><div style="" class="yo-button small" @click="rinnovoAdd()" type="primary" ><i class="material-icons">add</i></div></el-tooltip></div>
      </div>

      
      <div  class="row row-table" v-for="(itm, index) in filtrati" v-bind:key="index">
        <div class="col s2 yo-align-center">{{itm.anno}}</div>
        <div class="col s3">{{itm.importo | money('€ ')}}</div>
        <div class="col s6">{{itm.sconto | money('€ ')}} {{itm.scontomotivo}}</div>
        <div class="col s1 yo-align-center">
          <a v-if="societa.automatico==0" class="yo-button small" @click="rowDel(itm)" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">delete_forever</i></a>
          <router-link class="yo-button small" :to="'/rinnovo-edit/'+itm.societa+'/'+itm.id" style="color:#2E3C4A;"><i class="material-icons">edit</i></router-link>
        </div>
      </div>
  
  
</div>
</template>

<script>
export default {
  name: 'Si-home'
  ,mounted (){
    
  }
  ,props: {
    item: Object
  },
  methods:{
    rinnovoAdd () {
      this.$router.push('/rinnovo-edit/'+this.item.societa)
    },
    rowDel (row) {
      this.$confirm('Il rinnovo di '+this.$teras.money(row.importo,'€')+' per l\'annp '+row.anno+' verrà eliminato, continuare?', 'Warning', {
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(async () => {
        await this.$axios.deleteRow(row.id,'rinnovo')
        this.$socio.init()
      }).catch(() => {
        this.$message({
            type: 'info',
            message: 'Operazione annullata'
        })         
      })
      
    }
  }
  ,computed: {
    societa: function(){
      return this.$teras.getItemFromArrayObject(this.item.societa,'id',this.$teras._societa)
    },
      filtrati: function () {
      this.numitems = this.$socio._rinnovo.length

      console.log("TROVATI "+this.numitems+" RINNOVI per"+this.item.societa)
      
      if(this.numitems==0)
         return []
      
      var isFilter = []
      for (let item of this.$socio._rinnovo){

         if(   
         (item.societa==this.item.societa) 
         )
         
         isFilter.push(item)

      }
      this.numitems = isFilter.length
      return (isFilter.length>100) ? isFilter.slice(0, 100) : isFilter
      
      }
   }
}
</script>